import signedFetch from '../util/signedFetch.js';

export default (orgId, toolId = '') =>
  signedFetch('lmsConfig', `${__API_BASE__}/org/${orgId}/lms-config/tools/${toolId}/archive`, 'POST', {
    orgId,
    toolId,
    archived: true
  });
